var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileFilter = function SvgMobileFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.267 3.215H2.757h14.51Z",
    fill: "#C2B04A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.267 3.215H2.757",
    stroke: "#362B24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.876 12.215H1.219h12.657Z",
    fill: "#C2B04A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 12.215H1.219",
    stroke: "#362B24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.27 12.215h-1.543 1.543Z",
    fill: "#C2B04A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 12.215h-1.543",
    stroke: "#362B24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.906 1.363H2.76v3.705H.906V1.363ZM13.875 10.362h1.852v3.705h-1.852v-3.705Z",
    stroke: "#362B24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMobileFilter;